import DataTable from 'datatables.net-react';
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'; // Import SweetAlert2
import { AdminListService } from '../../services/AdminListService';
import { ResetPasswordService } from "../../services/ResetPasswordService";
import * as BullCache from "../../util/BullCache";
import From from '../components/From';
import To from '../components/To';



function Adminlist() {

    const [loading, setLoading] = useState(false);
    const [adminlist, setAdminlist] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const navigate = useNavigate();

    var user = BullCache.getFromCache("user");
    useEffect(() => {
        getAdmins();
    }, []);

    function getAdmins() {
        setLoading(true);
        setAdminlist([]);
        AdminListService.getAdmin({ 'adminId': user.adminId }).then(resp => {
            setLoading(false);
                if (resp.code === 1) {
                    if (resp.data.adminList.length > 0) {
                        setAdminlist(resp.data.adminList);
                    }
                }
        });
    }
    
    const handleSubmit = () => {
        getAdmins();
    }

    const handleFromDateChange = (newDate) => {
        setFromDate(newDate);
    };

    const handleToDateChange = (newDate) => {
        setToDate(newDate);
    };
    const handleNavigate = (event) => {
        const rowId = event.target.getAttribute("row-id");
        const dataId = event.target.getAttribute("data-id");

        navigate("/editAccount", { state: { rowId, adminIdMaster: dataId } });

    };
    const handlePasswordReset = (dataId) => {
        // Call the API to reset the password
        Swal.fire({
            title: "Are you sure?",
            text: "You are about to reset the password for this user.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, reset it!",
            cancelButtonText: "No, cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                const resetPayload = {
                    adminId: dataId,
                    loginId: user.adminId  // Include loginId along with adminId in the request
                };
                // If user clicks "Yes", proceed with password reset
                ResetPasswordService.resetPassword(resetPayload).then(resp => {
                    if (resp.code === 1) {
                        const userName = resp.data.userName;
                        const password = resp.data.password;
                        Swal.fire({
                            title: "Success!",
                            html: `Password reset successfully.<br> UserName: <b> ${userName} </b> <br> Password: <b> ${password} </b>`,
                            icon: "success",
                            confirmButtonText: "Okay",
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: resp.messages,
                            icon: "error"
                        });
                    }
                }).catch((error) => {
                    Swal.fire({
                        title: "Error",
                        text: "An error occurred while resetting the password.",
                        icon: "error"
                    });
                });
            } else {
                // If user clicks "No", do nothing
                Swal.fire({
                    title: "Cancelled",
                    text: "Password reset was cancelled.",
                    icon: "info"
                });
            }
        });
    };

const handleUserStatusChange = (dataId, status) => {
    const action = status === "ACTIVE" ? "Activate" : "Deactivate";
    Swal.fire({
        title: `Are you sure?`,
        text: `You are about to ${action} this user.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${action} it!`,
        cancelButtonText: "No, cancel"
    }).then((result) => {
        if (result.isConfirmed) {
            const statusPayload = {
                adminId: dataId,
                loginId: user.adminId,  // Include loginId along with adminId in the request
                status: status
            };

            AdminListService.changeStatus(statusPayload).then(resp => {
                if (resp.code === 1) {
                    Swal.fire({
                        title: "Success",
                        text: `User ${action}d successfully!`,
                        icon: "success"
                    });
                    getAdmins();
                } else {
                    Swal.fire({
                        title: "Error",
                        text: resp.messages,
                        icon: "error"
                    });
                }
            }).catch((error) => {
                Swal.fire({
                    title: "Error",
                    text:  error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
                    icon: "error"
                });
            });
        } 
    });
};

const handleClick = (event) => {
    if (event.target.classList.contains("table-btn")) {
        const buttonType = event.target.textContent.trim();
        const dataId = event.target.getAttribute("data-id");

        if (buttonType === "RP") {
            handlePasswordReset(dataId);
        }
        else if (buttonType === "A") {
            handleUserStatusChange(dataId, "DEACTIVE"); // Passing "DEACTIVE" status
        }
        else if (buttonType === "D") {
            handleUserStatusChange(dataId, "ACTIVE"); // Passing "ACTIVE" status
        } else {
            handleNavigate(event);
        }
    }
};

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);

    const columns = [
        {
            title: 'NAME', data: '', className: 'col-2 fss-09 text-nowrap', render: (data, type, full, meta) => {
                return full.firstName
            }
        },
        { title: 'LOGIN ID', data: 'userName', className: 'text-center fss-09 text-nowrap' },
        { title: 'PERCENTAGE', data: 'parentPercentage', className: ' col-1 text-center fss-09 text-nowrap' },
        { title: 'MASTER COUNT', data: 'masterCount', className: ' col-1 text-center fss-09 text-nowrap' },
        { title: 'BROKER COUNT', data: 'brokerCount', className: ' col-1 text-center fss-09 text-nowrap' },
        { title: 'CLIENT COUNT', data: 'userCount', className: ' col-1 text-center fss-09 text-nowrap' },
        {
            title: 'ACTION', data: '', className: 'col-2 text-center fss-09 text-nowrap',
            render: (data, type, row, full, meta) => {
                return `
                <button title="Edit Settings" class="table-btn font-bold fss-1 bg-warning btn-table"  row-id="${full.row}" data-id="${row.adminId}" >E</button>
                <button  title="Ledger" class=" font-bold fss-1 bg-danger btn-table "  row-id="${full.row}"  >L</button>
                    <button title="Reset Password" class="table-btn font-bold fss-1 bg-success btn-table" row-id="${full.row}" data-id="${row.adminId}">RP</button>
                <button class="font-bold fss-1 table-btn btn-table ${row.status ? 'bg-primary' : 'bg-secondary'}" row-id="${full.row}" data-id="${row.adminId}" title="${row.status ? 'Active': 'DeActive'}">
                ${row.status ? 'A' : 'D'}
                </button>`;
            }
        },
        { title: 'LOGIN TIME', data: 'lastLogin', className: 'text-center fss-09 text-nowrap' },
        {
            title: 'LOGIN IP',
            className: 'text-nowrap fss-09',
            render: (data, type, full, meta) => {
                const ip = full.loginIp;
                if (!ip) return null; // If there's no IP, return null (nothing to display)

                return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
            },
        },
        { title: 'JOIN TIME', data: 'createdAt', className: 'text-center fss-09 text-nowrap' },

    ];

    return (
        <div>
            <Card>
                <Card.Body>
                    <Container fluid>
                        <Row>

                            <Col xs={4} xl={1} className='margin-right'>
                                <b className='fss-05'>FROM </b><br />
                                <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                            </Col>
                            <Col xs={4} xl={1} className=' me-5'>
                                <b className='fss-05'>TO</b><br />
                                <To toDate={toDate} setToDate={setToDate} />
                            </Col>

                            <Col xs={4} sm={3} xl={1} className="mt-4">
                                <Button variant="success" size="sm w-75" onClick={handleSubmit}>
                                    <b className="fss-08">SUBMIT</b>
                                </Button>
                            </Col>

                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>

                        </Row>


                    </Container>
                </Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable id="table" className="mt-1 table table-striped bg-secondary-row fss-09"
                                data={adminlist} columns={columns}
                            />
                        )}
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}
export default Adminlist;